import { LABEL_MIN } from './timeUtils'
import { HourLabel } from './HourLabel'

export function DayGridTimeAxis({
  gridMin,
  gridMax,
  stageCount,
  toRowLine,
}: {
  gridMin: number
  gridMax: number
  stageCount: number
  toRowLine: (minutes: number) => number
}) {
  const firstHour = Math.ceil(gridMin / 60) * 60
  const labels = []
  for (let t = firstHour + 60; t < gridMax; t += 60) {
    const rowStart = toRowLine(t)
    const rowEnd = toRowLine(Math.min(t + 60, gridMax))
    labels.push(
      <div
        key={`tl-${t}`}
        style={{
          gridColumn: 1,
          gridRow: `${rowStart} / ${rowEnd}`,
          position: 'sticky',
          left: 0,
          zIndex: 35,
        }}
        className="flex items-start justify-center pointer-events-none"
      >
        <HourLabel minutes={t} />
      </div>,
    )
  }

  const firstLine = Math.ceil(gridMin / LABEL_MIN) * LABEL_MIN
  const lines = []
  for (let t = firstLine; t < gridMax; t += LABEL_MIN) {
    const rowLine = toRowLine(t)
    for (let j = 0; j < stageCount; j++) {
      lines.push(
        <div
          key={`hl-${t}-${j}`}
          style={{
            gridColumn: j + 2,
            gridRow: `${rowLine} / ${rowLine + 1}`,
            pointerEvents: 'none',
          }}
          className="border-t border-border/40"
        />,
      )
    }
  }

  return (
    <>
      {/* Time labels — overlay the grid at the left edge, sticky so they
          stay visible while scrolling horizontally. Pointer-events: none so
          clicks pass through to set blocks underneath. */}
      {labels}

      {/* Gridlines — one per stage column, every LABEL_MIN minutes.
          Cell sits one row below the line and uses border-t so it lands on the
          same side of the row line as the time column's border-t (avoids 1px offset). */}
      {lines}
    </>
  )
}
